import { Link } from "react-router-dom";
import { useT } from "@/context/LanguageContext";
import { useSEO } from "@/hooks/useSEO";

const FOUNDER_PHOTO =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_lisboa-boutique-ui/artifacts/zavsn1tb_WhatsApp%20Image%202026-07-17%20at%2021.24.35.webp";

/**
 * About Us — the founders' story. Warm, personal, editorial layout inspired
 * by ladypipa.com/nosotras but tuned to GOYA's marigold + serif voice.
 */

const About = () => {
  const { t } = useT();
  useSEO({
    title: undefined, // Uses the /about entry in seo.js
  });

  return (
    <div data-testid="about-page" className="pt-24 md:pt-32 pb-24 bg-[var(--gl-bg)]">
      {/* Hero — founder portrait + editorial title */}
      <section className="max-w-6xl mx-auto px-6 md:px-12 grid md:grid-cols-2 gap-10 md:gap-16 items-center">
        <div className="relative">
          <img
            src={FOUNDER_PHOTO}
            alt={t("about.photo.alt")}
            data-testid="about-founder-photo"
            className="w-full h-auto object-cover"
            loading="eager"
          />
        </div>
        <div>
          <div className="font-badge text-[10px] md:text-[11px] tracking-[0.3em] text-[var(--gl-orange-hover)]">
            {t("about.eyebrow")}
          </div>
          <h1 className="font-serif-display text-5xl md:text-7xl mt-3 tracking-tight text-[#241C18] leading-[0.92]">
            {t("about.title")}
          </h1>
          <p className="mt-6 md:mt-8 text-base md:text-lg text-[#241C18] leading-relaxed">
            {t("about.intro1")}
          </p>
          <p className="mt-4 text-base md:text-lg text-[#241C18] leading-relaxed">
            {t("about.intro2")}
          </p>
          <p className="mt-4 text-sm md:text-base text-[var(--gl-orange-hover)] italic">
            {t("about.twins")}
          </p>
        </div>
      </section>

      {/* Sign-off + CTA */}
      <section className="max-w-3xl mx-auto px-6 md:px-12 mt-20 md:mt-28 text-center">
        <div className="font-serif-display text-2xl md:text-4xl italic text-[#241C18]">
          {t("about.signoff")}
        </div>
        <div className="font-badge text-[10px] tracking-[0.32em] text-[var(--gl-orange-hover)] mt-3">
          {t("about.signoff.sign")}
        </div>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <Link to="/collection/new-in" className="btn-orange">{t("about.cta.shop")}</Link>
          <a
            href="https://www.instagram.com/goyalisboa"
            target="_blank"
            rel="noreferrer"
            className="font-badge text-[11px] tracking-[0.24em] text-[#241C18] underline underline-offset-4 hover:text-[var(--gl-orange-hover)]"
          >
            {t("about.cta.follow")}
          </a>
        </div>
      </section>
    </div>
  );
};

export default About;
